import { SessionChange, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { magic, CtaStyle } from '@gig/magic-sdk';
import { store } from '../store/index.js';
import { UserRolesUpdated } from '@gig/magic-common/dist/util/helpers/user';

/**
 * Mixin responsible for handling opt in buttons on promotions
 */
var PromotionsOptinMixin = /** @class */ (function (_super) {
    __extends(PromotionsOptinMixin, _super);
    function PromotionsOptinMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOptingIn = false;
        _this.userRoles = [];
        _this.isLoggedIn = false;
        _this.optInPromoName = '';
        _this.optInCta = null;
        _this.shouldResumeOptIn = false;
        return _this;
    }
    PromotionsOptinMixin.prototype.syncUserRoles = function (ev) {
        if (ev.roles) {
            var roles = ev.roles.map(function (role) { return role.name; });
            this.userRoles = roles;
        }
    };
    PromotionsOptinMixin.prototype.onSessionChange = function (isLoggedIn) {
        var _a;
        this.isLoggedIn = isLoggedIn;
        if (isLoggedIn) {
            return (this.userRoles = ((_a = magic.session.getUser()) === null || _a === void 0 ? void 0 : _a.roles) || []);
        }
        this.userRoles = [];
    };
    PromotionsOptinMixin.prototype.optIn = function (promoName, cta) {
        return __awaiter(this, void 0, void 0, function () {
            var user, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = magic.session.getUser();
                        if (!this.isOptIn(cta) || this.isOptingIn) {
                            return [2 /*return*/];
                        }
                        if (!user) {
                            this.__requireLogin();
                            this.shouldResumeOptIn = true;
                            this.optInCta = cta;
                            this.optInPromoName = promoName;
                            return [2 /*return*/];
                        }
                        if (!cta.roles) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.isOptingIn = true;
                        return [4 /*yield*/, magic.methods.promotions.optIn(promoName, this.magicConfig.language, cta.text, user.id)];
                    case 2:
                        _a.sent();
                        this.__handleOptInSuccess();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.__handleOptInError(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isOptingIn = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsOptinMixin.prototype.isOptIn = function (cta) {
        return cta.style === CtaStyle.OPTIN;
    };
    PromotionsOptinMixin.prototype.resumeOptIn = function (isLoggedIn) {
        if (this.shouldResumeOptIn && isLoggedIn) {
            this.shouldResumeOptIn = false;
            this.optIn(this.optInPromoName, this.optInCta);
        }
    };
    /**
     * Emitted when opt-in button was clicked by logged out user
     */
    PromotionsOptinMixin.prototype.__requireLogin = function () {
        return;
    };
    /**
     * Emitted when there was an error during opt-in.
     * Provides error message
     */
    PromotionsOptinMixin.prototype.__handleOptInError = function (error) {
        return error;
    };
    /**
     * Emitted after successful opt-in
     */
    PromotionsOptinMixin.prototype.__handleOptInSuccess = function () {
        return;
    };
    __decorate([
        UserRolesUpdated(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PromotionsOptinMixin.prototype, "syncUserRoles", null);
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PromotionsOptinMixin.prototype, "onSessionChange", null);
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PromotionsOptinMixin.prototype, "resumeOptIn", null);
    __decorate([
        Emit('requireLogin'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PromotionsOptinMixin.prototype, "__requireLogin", null);
    __decorate([
        Emit('optInError'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PromotionsOptinMixin.prototype, "__handleOptInError", null);
    __decorate([
        Emit('optInSuccess'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PromotionsOptinMixin.prototype, "__handleOptInSuccess", null);
    PromotionsOptinMixin = __decorate([
        Component({
            store: store,
        })
    ], PromotionsOptinMixin);
    return PromotionsOptinMixin;
}(Mixins(MagicConfigMixin)));

export { PromotionsOptinMixin };
